import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { HttpBaseService } from 'src/app/base/http-base.service';
import * as globalserviceActions from 'src/app/STORE/actions/globalservice.actions';

@Injectable()
export class GlobalServiceEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
}
